<template>
  <div class="apply-confirm">
    <div class="header">
      <van-nav-bar
        title="发票预览"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div :class="['sell',marginTop ? 'sell-top' : '']">
      <p class="sell-name">销方名称</p>
      <div class="change-sell-company">
        {{this.$store.state.user.company.name}}
      </div>
    </div>
    <div class="buy">
      <p class="buy-title">购方名称</p>
      <div class="buy-name">
        {{detailData.purchaserName}}
      </div>
      <div class="label">
        <div class="left">购方税号</div>
        <div class="right">{{detailData.purchaserTaxNo}}</div>
      </div>
      <div class="label">
        <div class="left">地址,电话</div>
        <div class="right">{{detailData.purchaserAddress}}</div>
      </div>
      <div class="label">
        <div class="left">开户行及账号</div>
        <div class="right">{{detailData.purchaserBankName}}</div>
      </div>
    </div>

    <div class="ticket">
      <div class="label">
        <div class="left">价税合计</div>
        <div class="right">{{autoNumber(Number(messageJiner))}}</div>
      </div>
      <div class="label">
        <div class="left">金额</div>
        <div class="right">{{autoNumber(Number(handleOncount(Number(messageJiner), Number(messageShuier), 'sub')))}}</div>
      </div>
      <div class="label">
        <div class="left">税额</div>
        <div class="right">{{autoNumber(Number(messageShuier))}}</div>
      </div>
      <div class="label">
        <div class="left">备注</div>
        <div class="right">{{detailData.remark}}</div>
      </div>
    </div>
    <div>
    </div>

     <div class="shop-detail">
        <div class="shop-detail-title">
          <div>商品明细  <span>({{detailData ? detailData.details.length : '0'}})</span></div>
          <div>向左滑动查看更多</div>
        </div>
        <div class="more">
          <div class="more-title">
            <div class="more-left">
              <div class="more-left-title">项目名称</div>
              <div class="more-names" v-for="(item,index) in detailData.details" :key="index">
                {{item.goodsName}}
              </div>
            </div>
            <div class="more-right">
              <div class="scroll-wrp">
                <section>
                  <div>金额</div>
                  <div>税率</div>
                  <div>税额</div>
                  <div>个数</div>
                </section>
                <div class="moer-content list-bottom" v-for="(item,index) in detailData.details" :key="index">
                  <div>{{autoNumber(Number(item.amountWithTax))}}</div>
                  <div>{{autoNumber(Number(item.taxRate))}}</div>
                  <div>{{autoNumber(Number(item.taxAmount))}}</div>
                  <div>{{item.quantity}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="other">
        <p class="other-title">其他内容</p>
        <div class="label">
          <div class="left">说明注释</div>
          <div class="right">{{detailData.notes}}</div>
        </div>
        <p class="upload">上传附件</p>
        <div class="img">
          <div v-for="(item,index) in detailData.files" :key="index">
            <img :src="item.url" alt="">
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  NavBar
} from 'vant'
import {
  onCount,
  NumFormat
} from '@utils/basicUtil'
import { mapState, mapActions } from 'vuex'
export default {
  props: ['goodsList', 'comeFormDian'],
  data: () => ({
    messageJiner: 0,
    messageShuier: 0,
    marginTop: false
  }),
  computed: {
    ...mapState('applyInfo', ['detailData']),
    autoNumber () {
      return function (num) {
        return NumFormat(num)
      }
    }
  },
  async mounted () {
    if (this.$route.query.id) {
      await this.getInvoiceInfo(this.$route.query.id)
      if (Object.keys(this.detailData).length) {
        this.detailData.details.forEach((item, index) => {
          this.messageJiner += Number(item.amountWithTax)
          this.messageShuier += Number(this.handleOncount(Number(item.amountWithTax), Number(item.taxRate), 'mul'))
        })
      }
    }
  },
  methods: {
    ...mapActions('applyInfo', ['getInvoiceInfo']),
    handleOncount (front, rear, symbols) {
      let result = onCount[symbols](front, rear)
      return Number(result).toFixed(2)
    },
    onClickLeft () {
      this.$router.go(-1)
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [NavBar.name]: NavBar
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
